module.exports = __webpack_public_path__ + "img/473f056.png";